/**
 * Marken und Bereiche (S5).
 *
 * Sascha: „Stellen in der Zeitleiste benennen, und aus einem Bereich heraus
 * exportieren.“ Zwei Dinge, die dasselbe Werkzeug bedienen: eine Marke ist ein
 * Zeitpunkt mit Namen, ein Bereich ein Anfang und ein Ende.
 */
/**
 * Steht an dieser Stelle schon eine Marke?
 *
 * Gefragt wird mit einer Toleranz und nicht auf die Nanosekunde: wer den
 * Abspielkopf auf eine Marke setzt und noch einmal „Marke setzen“ tippt, meint
 * die, die dort steht -- und bekommt sonst zwei übereinander, von denen er nur
 * eine sieht. Ein Einzelbild ist das richtige Mass dafür.
 */
export function markeBei(marken, at, toleranz) {
    let beste = null;
    let abstand = Number.POSITIVE_INFINITY;
    for (const m of marken) {
        const d = Math.abs(m.at - at);
        if (d <= toleranz && d < abstand) {
            beste = m;
            abstand = d;
        }
    }
    return beste;
}
/**
 * Die nächste Marke vor oder hinter einer Stelle.
 *
 * `richtung` ist 1 nach hinten und -1 nach vorn. Eine Marke *genau* an der
 * Stelle zählt nicht als Ziel -- sonst führte „nächste“ zurück auf die, bei
 * der man gerade steht, und der Knopf täte nichts. Die Toleranz ist dieselbe
 * wie beim Setzen, aus demselben Grund.
 */
export function naechsteMarke(marken, at, richtung, toleranz = 0) {
    const kandidaten = marken
        .filter((m) => (richtung === 1 ? m.at > at + toleranz : m.at < at - toleranz))
        .sort((a, b) => (richtung === 1 ? a.at - b.at : b.at - a.at));
    return kandidaten[0] ?? null;
}
/**
 * Einen Bereich in Form bringen -- oder sagen, dass es keiner ist.
 *
 * Wer die beiden Enden in der falschen Reihenfolge setzt, meint trotzdem den
 * Bereich dazwischen; das zu drehen ist keine Freundlichkeit, sondern die
 * einzige Lesart. Über das Ende des Schnitts hinaus gibt es nichts zu
 * exportieren, also wird dort geschnitten. Und was kürzer ist als ein
 * Einzelbild, ist kein Bereich, sondern ein verrutschter Fingertipp: dann
 * `null`, damit niemand einen leeren Film bestellt.
 */
export function bereichAus(von, bis, dauer, mindestens) {
    const a = Math.max(0, Math.min(von, bis));
    const b = Math.min(dauer, Math.max(von, bis));
    // Eine Nanosekunde Nachsicht beim Vergleich: `(5 + 1/30) - 5` ist in
    // Gleitkomma nicht genau `1/30`, und ohne diese Zeile wäre ein Bereich von
    // *genau* einem Einzelbild keiner. Wer die beiden Enden auf benachbarte
    // Bilder setzt, meint aber genau den.
    if (!(b - a >= mindestens - 1e-9))
        return null;
    return { von: a, bis: b };
}
//# sourceMappingURL=marken.js.map